import { SendEventProps } from '../../interface/biEvents';

export const mpClickedTagsShowMore = () =>
    ({
        eventName: 'Gig page - Seller card - tags clicked show more',
    } satisfies SendEventProps);
